/** Carry only launch context between domains, not another view's filters. */
export function destinationSearch(previous: Record<string, unknown>, destination: Record<string, string>) {
  const next: Record<string, string> = {};
  for (const key of ["organization_id", "legal_entity_id"]) {
    if (typeof previous[key] === "string") next[key] = previous[key];
  }
  return { ...next, ...destination };
}
